"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useOverlayBgStyles;
var _Settings = _interopRequireDefault(require("../../../layouts/default/Settings"));
var _helpers = require("../../../layouts/default/helpers");
var _Settings2 = _interopRequireDefault(require("../../../layouts/upload/Settings"));
var _helpers2 = require("../../../layouts/upload/helpers");
var _style = _interopRequireDefault(require("../../../layouts/birds/style.css"));
var _style2 = _interopRequireDefault(require("../../../layouts/geometric/style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function useOverlayBgStyles() {
  var layout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isShowingLayoutBgColor = arguments.length > 1 ? arguments[1] : undefined;
  switch (layout.handle) {
    case 'default':
      return {
        style: (0, _helpers.getBgStyle)(_objectSpread(_objectSpread({}, _Settings["default"]), layout.settings), isShowingLayoutBgColor)
      };
    case 'upload':
      return {
        style: (0, _helpers2.getBgStyles)(_objectSpread(_objectSpread({}, _Settings2["default"]), layout.settings), isShowingLayoutBgColor)
      };
    case 'hhlBirds':
      return {
        className: _style["default"].show
      };
    case 'geometric':
      return {
        className: _style2["default"].show
      };
    default:
      return {};
  }
}